import {priority} from '@priority-software/priority-proto-api/lib';
import {validNumber} from '@priority-software/priority-utils/lib/date';

export function isTime(type: priority.netitems.form.ColumnType): boolean {
    return (
        type === priority.netitems.form.ColumnType.Date14 ||
        type === priority.netitems.form.ColumnType.Time5
    );
}

export function formatTime(hours: number, minutes: number, hours12: boolean = false) {
    const ampm = hours12 ? (hours > 12 ? ' PM' : ' AM') : '';
    const defaultHoursValue = hours12 ? '12' : '00';
    const hoursString = hours
        ? convertToXDigitString(hours12 && hours > 12 ? hours - 12 : hours, 2)
        : defaultHoursValue;
    const minutesString = minutes ? convertToXDigitString(minutes, 2) : '00';
    return `${hoursString}:${minutesString}${ampm}`;
}

export function convertToXDigitString(
    value: number,
    targetLength: number,
    defaultCharacter: string = '0'
) {
    let valueString = value.toString();
    const defaultValue = defaultCharacter.repeat(targetLength);

    if (valueString.length < targetLength) {
        valueString = defaultValue.slice(0, -valueString.length) + valueString;
    }
    return valueString;
}

export function getTimeStringFormat(lang: string) {
    return lang === '3' ? 'hh:mm a' : 'HH:mm';
}

export function isHour12Format(lang: string): boolean {
    return lang === '3';
}

export function formatStringToTimeObj(value: string): Date {
    const dateTime = new Date();

    const timeParts = value.split(' ');
    const time = timeParts[0];
    const period = timeParts[1];

    dateTime.setHours(parseHours(time, period));
    dateTime.setMinutes(parseMinutes(time));

    return dateTime;
}

export function parseHours(timeString: string, period: string): number {
    if (!timeString && !period) {
        return 0;
    }
    let hours = Number.parseInt(timeString.slice(0, 2));
    if (period) {
        if (hours === 12) {
            if (period === 'AM') {
                hours = 0;
            }
        } else {
            hours += period === 'PM' ? 12 : 0;
        }
    }
    return hours;
}

export function parseMinutes(timeString: string): number {
    return timeString ? Number.parseInt(timeString.slice(3)) : 0;
}

export function format6Time(hours: number, minutes: number) {
    const hoursString = hours ? convertToXDigitString(hours, 3) : '000';
    const minutesString = minutes ? convertToXDigitString(minutes, 2) : '00';
    return `${hoursString}:${minutesString}`;
}

export const getRawTimeSum = (newValue: string, oldValue: string) => {
    const typing = newValue.length > oldValue.length;
    const removing = !typing;

    if (newValue.length === 3 && typing) {
        return `${newValue}:`;
    } else if (newValue.length === 3 && removing) {
        return newValue.substring(0, 2);
    }
    return newValue;
};

export const isValidTimeSum = (value: string) => {
    if (value && !value.match(/([0-9:?])/)) {
        return false;
    }

    let valid = true;

    if (value.split(':').length > 2) {
        return false;
    }

    const minutes = value.split(':')[1];
    if (minutes && minutes.length) {
        valid = minutes.length <= 2 && validNumber(minutes[0], 5) && validNumber(minutes, 59);
    }
    return valid;
};

export const getDataTime6Format = (value: string): {hours?: number; minutes?: number} => {
    const [parsedHours, parsedMinutes] = value.split(':');
    const hours = Number(parsedHours);
    const minutes = Number(parsedMinutes);

    if (hours || minutes) return {hours, minutes};

    return {};
};

export const formatTimeTo24HourClock = (value: string) => {
    // check if the value is already in 24 hour format
    if (value.length === 5) return value;
    const timeString = value.substring(0, 5);
    const ampm = value.slice(-2);

    if (ampm === 'PM') {
        const hours = parseHours(timeString, 'PM');
        const minutes = parseMinutes(timeString);
        return `${hours}:${minutes}`;
    } else {
        return value.slice(0, value.length - 2);
    }
};
